import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api';

// Categories come from the database (/api/categories); nothing is hardcoded in the UI.
// `categories` includes inactive ones (needed for filters and for displaying history);
// `activeCategories` is what new entries may choose from.
export default function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_BASE_URL}/api/categories`, { params: { all: 1 } })
      .then((res) => { if (!cancelled) setCategories(Array.isArray(res.data) ? res.data : []); })
      .catch(() => { if (!cancelled) setError(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const activeCategories = useMemo(() => categories.filter((c) => c.is_active), [categories]);
  const byName = useMemo(() => {
    const map = {};
    categories.forEach((c) => { map[c.name] = c; });
    return map;
  }, [categories]);

  return { categories, activeCategories, byName, loading, error };
}
